import React, { useEffect, useRef, useState } from 'react'

const normalizeManualTime = (value = '') => {
  const raw = String(value).trim()
  let hourText = ''
  let minuteText = ''
  const match = raw.match(/^(\d{1,2}):(\d{1,2})$/)

  if (match) {
    hourText = match[1]
    minuteText = match[2]
  } else {
    const digits = raw.replace(/\D/g, '')
    if (!digits || digits.length < 3 || digits.length > 4 || digits !== raw) {
      return null
    }
    hourText = digits.slice(0, -2)
    minuteText = digits.slice(-2)
  }

  const hour = Number(hourText)
  const minute = Number(minuteText)
  if (Number.isNaN(hour) || Number.isNaN(minute) || hour > 23 || minute > 59) {
    return null
  }

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

const normalizePreviewTime = (value = '') => {
  const raw = String(value).trim()
  let hourText = ''
  let minuteText = ''
  const match = raw.match(/^(\d{1,2}):(\d{2})$/)

  if (match) {
    hourText = match[1]
    minuteText = match[2]
  } else {
    const digits = raw.replace(/\D/g, '')
    if (digits.length !== 4 || digits !== raw) {
      return null
    }
    hourText = digits.slice(0, 2)
    minuteText = digits.slice(2)
  }

  const hour = Number(hourText)
  const minute = Number(minuteText)
  if (Number.isNaN(hour) || Number.isNaN(minute) || hour > 23 || minute > 59) {
    return null
  }

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

const ManualTimeInput = ({ value, onChange, onConfirm, onPreview }) => {
  const [draft, setDraft] = useState(value || '')
  const [isInvalid, setIsInvalid] = useState(false)
  const skipBlurRef = useRef(false)

  useEffect(() => {
    setDraft(value || '')
    setIsInvalid(false)
  }, [value])

  const applyTime = () => {
    const time = normalizeManualTime(draft)

    if (!time) {
      setIsInvalid(true)
      return
    }

    setDraft(time)
    setIsInvalid(false)
    onChange(time)
    return time
  }

  const handleChange = (event) => {
    const nextDraft = event.target.value.replace(/[^\d:]/g, '').slice(0, 5)
    setDraft(nextDraft)
    setIsInvalid(false)

    const previewTime = normalizePreviewTime(nextDraft)
    if (previewTime && onPreview) {
      onPreview(previewTime)
    }
  }

  return (
    <input
      type="text"
      className={`form-control form-control-sm text-center${
        isInvalid ? ' is-invalid' : ''
      }`}
      style={{ width: 118 }}
      value={draft}
      placeholder="HH:mm"
      inputMode="numeric"
      maxLength={5}
      onChange={handleChange}
      onBlur={() => {
        if (skipBlurRef.current) {
          skipBlurRef.current = false
          return
        }

        applyTime()
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          const time = applyTime()

          if (time && onConfirm) {
            skipBlurRef.current = true
            onConfirm(time)
          }
        }
      }}
    />
  )
}

export default ManualTimeInput
